import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../services/user.service";
import { DisplayService } from '../services/display.service';
import { Observable } from 'rxjs';
import { AppText } from '../interfaces/common';

@Component({
  selector: 'app-upload-geo-files',
  templateUrl: './upload-geo-files.component.html',
  styleUrls: ['./upload-geo-files.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadGeoFilesComponent implements OnInit, OnChanges {

  @Input() selText: AppText = {};

  geoForm = new FormGroup({
    name: new FormControl<string>("", [Validators.required.bind(Validators)]),
    geoFile: new FormControl<File | null>(null),
    datum: new FormControl<string>("")
  });

  singleGeoFile: File | undefined;
  fileAdded: boolean = false;
  uploadFileText: string = '';
  /*
    state can be: "main" | "success" | "error" | "waiting"
    main: is the original file upload card
    waiting: is when we are waiting from response from server after hitting submit
    success: is when file was upload successfully
    error: is when something went wrong during upload (Server rejected the request/file)
  */
  state: string = "main";

  constructor(private userService: UserService,
              private displayService: DisplayService,
              private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    //console.log(this.fc.status)
    this.uploadFileText = this.selText["uploadFileHint"];
  }

  ngOnChanges(): void {
    this.uploadFileText = this.selText["uploadFileHint"];
    /**
    When selText changes we run changeDetectorRef.detectChanges(), usually not necessary but otherwise
    we get the error from language change in mat-option.
     */
  }

  handleClosing(): void {
    this.displayService.toggleUploadFilesActive();
  }

  fileFromDragAndDrop(file: File): void {
    this.singleGeoFile = file;
    this.fileAdded = true;
    this.uploadFileText = file.name;
  }

  fileFromBrowse(e: Event): void {
    const fileInput = e.target as HTMLInputElement;
    const file: File | null = fileInput.files?.[0] || null;
    if (file) {
      this.singleGeoFile = file;
      this.fileAdded = true;
      this.uploadFileText = file.name;
    }
  }

  goBack(): void {
    this.state = "main"
    this.resetToInit()
  }

  goToLayerManager(): void {
    this.displayService.toggleUploadFilesActive()
    this.displayService.toggleAddLayerActive()
  }

  // Should reset main state to init so that users have a empty slate to add more files
  resetToInit(): void {
    this.geoForm = new FormGroup({
      name: new FormControl<string>("", [Validators.required.bind(Validators)]),
      geoFile: new FormControl<File | null>(null),
      datum: new FormControl<string>("", []),
    });

    this.uploadFileText = this.selText["uploadFileHint"];
    this.singleGeoFile = undefined;
    this.fileAdded = false;
  }

  handleSubmit() {
    //console.log("Submitting to Server")
    if (this.singleGeoFile === undefined) {
      window.alert("No valid file choosen");
      return
    }

    this.state = "waiting"
    
    let datum = this.geoForm.get("datum")?.value;

    //datum is only empty string if nothing is selected
    if (datum !== "") {
      datum = datum + "/"
    } else {
      datum = "0/"
    }

    const formData: FormData = new FormData();
    formData.append("file", this.singleGeoFile, this.singleGeoFile.name)
    
    //const postGeoFileObs: Observable<any> = this.userService.postGeoFile(formData, datum, this.singleGeoFile.name)
    const postGeoFileObs: Observable<any> = (() =>
      this.userService.postGeoFile(formData, datum, this.singleGeoFile.name))();
    
    //this.httpClient.post(environment.bendURL + `/gsman/add/${userName}/${datum}${this.singleGeoFile.name}`, formData, {headers: customHeaders})
    postGeoFileObs.subscribe(() => {
        this.state = "success"
        /*
        //Need to mark it for check/rerendering since the state has changed from "waiting" to "success". 
        Notice that in the top of handleSubmit() I change this.state to "waiting" and this view was reflected in the
        view! But then when I change this state inside of this callback then the change is not reflected in the view.
        Therefore I manually mark the component for changes with markForCheck.

        detectChanges() updates this component and all of its children.
        markForCheck() Tells angular to check for changes here and all the way to the root during next changeDetectionCycle.
        Note: markForCheck() does not trigger a changeDetection to occur but detectChanges() does.
        */
        this.changeDetectorRef.markForCheck()
      },
      (error) => {
        console.error(error)
        this.state = "error"
        this.changeDetectorRef.markForCheck()
      }
    )
  }
}